import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';
import { noop } from 'ui-components/default-props/noop';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import style from './item-quantity-in-shipments.module.less';
import { EditableSection } from './editable-section';

const BIG_NUMBER_THRESHOLD = 10000;

const messages = defineMessages({
  editableText: {
    description: 'itemQuantityInShipments.editableText',
    defaultMessage: 'Do things',
    id: 'qdzRUN',
  },
});

const ItemQuantityInShipments = ({
  editable = false,
  editableQuantity = 0,
  editableText = messages.editableText,
  quantityDone,
  totalQuantity,
  onEditableQuantityChanged = noop,
  className = '',
  showInShipments = true,
}) => {
  const topLevelClassnames = classnames(style['item-quantity-in-shipments'], className, {
    [style.editable]: editable,
  });
  const currentQuantityClassnames = classnames(style['current-quantity'], style.section, {
    [style['totally-shipped']]: quantityDone === totalQuantity,
    [style['big-number']]: totalQuantity > BIG_NUMBER_THRESHOLD,
  });
  return (
    <div className={topLevelClassnames}>
      {editable && (
        <EditableSection
          editableQuantity={editableQuantity}
          editableText={editableText}
          onEditableQuantityChanged={onEditableQuantityChanged}
          quantityDone={quantityDone}
          totalQuantity={totalQuantity}
        />
      )}
      {showInShipments && (
        <div className={currentQuantityClassnames}>
          <div className={style['section-title']}>
            <FormattedMessage defaultMessage='In Shipments' description='itemQuantityInShipments.inShipments' id='ZBqOzz' />
          </div>
          <div className={style['section-content']}>
            <FormattedMessage
              defaultMessage='{quantityDone}of{totalQuantity}'
              description='itemQuantityInShipments.currentQuantity'
              id='H49gAZ'
              values={{
                quantityDone: <b>{quantityDone}</b>,
                totalQuantity: <b>{totalQuantity}</b>,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

ItemQuantityInShipments.propTypes = {
  editable: PropTypes.bool,
  editableQuantity: PropTypes.number,
  editableText: MessageDescriptorPropType,
  quantityDone: PropTypes.number.isRequired,
  totalQuantity: PropTypes.number.isRequired,
  onEditableQuantityChanged: PropTypes.func,
  className: PropTypes.string,
  showInShipments: PropTypes.bool,
};

export default ItemQuantityInShipments;
